// @flow

import React from 'react'
import { connect } from 'react-redux'
import { Modal, Button } from 'semantic-ui-react'
import { silver, white, prussian } from 'constants/inlineStyles'
import FlyerButton from '../../FlyerDetailMenu/components/FlyerButton'
// import { getFlyerOwnerEmail } from '../../../selectors'
import withMetricClick from '../../../withMetricClick'
import ModalContainer from './ModalContainer'
import CopyToClipboard from './CopyToClipboard'

let styles = {}

type ReduxStateProps = {|
  +value: ?string
|}

type Props = {|
  ...ReduxStateProps
|}

const SimpleEmailProgramProviderModal = ({ value: flyerOwnerEmail }: Props) => {
  const email = flyerOwnerEmail || 'No Email Address Provided'
  const ButtonWithEmailCopyMetric = withMetricClick(
    'email-modal-copy-email-address'
  )(Button)
  const ButtonWithEmailMailtoMetric = withMetricClick(
    'email-modal-mailto-link'
  )(FlyerButton)

  // FIXME: (quinkinser) use FlyerButton instead of Button in all instances
  return (
    <ModalContainer header="Email Organization">
      <Modal.Content style={styles.contentWrapper}>
        <div style={styles.emailAddress}>{email}</div>
      </Modal.Content>

      <Modal.Actions style={styles.actions}>
        <CopyToClipboard clipboardContent={email}>
          <ButtonWithEmailCopyMetric
            className="flyer-button"
            style={{ ...styles.button, ...styles.secondaryColors }}
          >
            Copy
          </ButtonWithEmailCopyMetric>
        </CopyToClipboard>
        <ButtonWithEmailMailtoMetric
          type="action"
          style={styles.button}
          hrefAction={`mailto:${email}`}
          label="Email"
        />
      </Modal.Actions>
    </ModalContainer>
  )
}

styles = {
  largeSilverBorder: { border: `4px solid ${silver}` },
  button: {
    minWidth: '120px',
    border: `2px solid ${prussian}`,
    borderRadius: '.5em'
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    paddingLeft: '40px',
    paddingRight: '40px'
  },
  emailAddress: {
    fontWeight: 200,
    textAlign: 'center',
    width: '100%',
    fontSize: '22px',
    wordWrap: 'break-word'
  },
  secondaryColors: {
    color: white,
    backgroundColor: prussian
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  }
}

export default connect()(SimpleEmailProgramProviderModal)



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/ModalManager/components/SimpleEmailProgramProviderModal.js